import React from 'react'

import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import IconClearText from '@material-ui/icons/Close'
import IconSearch from '@material-ui/icons/PanoramaFishEye'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import { Vector as VectorLayer } from 'ol/layer'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, setDirectionsStartLocation } from 'api/actions'
import GetAddressFromHereMaps from 'data/GetAddressFromHereMaps'
import GetLocationLabel from 'drawer/tabs/search/panels/GetLocationLabel'
import ShowRoute from 'drawer/tabs/search/panels/ShowRoute'
import PoziMap from 'map/map'

const KEYCODE_ENTER = 13 // https://www.javascriptkeycode.com/

const styles = theme => ({
  root: {},
  iconSearch: {
    color: '#757575'
  },
  header: {},
  textField: {
    background: 'white',
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 8
  }
})

class SearchPanelDirectionsStart extends React.Component {
  constructor (props) {
    super(props)

    this.pure = {}
    this.pure.handleChange = this.handleChange.bind(this)
    this.pure.addornment = this.buildSearchBoxAddornment()

    const styles = {
      startMarker: new Style({
        image: new Icon({
          src: 'img/custom/select_marker_directions_start.png'
        })
      })
    }

    this.pure.olLayerMarker = new VectorLayer({
      zIndex: 1,
      source: new VectorSource({
        features: []
      }),
      style: function (feature) {
        return styles[feature.get('type')]
      }
    })

    PoziMap().addLayer(this.pure.olLayerMarker)
  }

  updateMarkerLocation () {
    const { startLocation } = this.props
    const coords = get(startLocation, 'coords', [])
    if (coords.length === 2) {
      const startLocation3857 = window.appObject.transformFrom4326(coords)
      const startMarker = new Feature({
        type: 'startMarker',
        geometry: new Point(startLocation3857)
      })
      this.pure.olLayerMarker.getSource().clear()
      this.pure.olLayerMarker.getSource().addFeature(startMarker)
    } else {
      this.pure.olLayerMarker.getSource().clear()
    }
  }

  componentDidMount () {
    this.update()
  }

  handleChange (event) {
    console.log('Do not set location to a string, it is [lng,lat]')
  }

  clearSearch () {
    this.props.setDirectionsStartLocation([])
  }

  // https://github.com/mui-org/material-ui/pull/16672
  handleMouseDownPassword (event) {
    event.preventDefault()
  }

  buildSearchBoxAddornment () {
    const { classes } = this.props
    return {
      inputProps: {
        'data-lpignore': 'true'
      },
      startAdornment: (
        <InputAdornment position="start">
          <IconSearch className={classes.iconSearch} />
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position="end">
          <IconButton edge="end" size="small" aria-label="clear search" onClick={this.clearSearch.bind(this)} onMouseDown={this.handleMouseDownPassword}>
            <IconClearText className={classes.iconClearText} />
          </IconButton>
        </InputAdornment>
      ),
      onKeyDown: (e) => {
        if (e.keyCode === KEYCODE_ENTER) {
          console.log('Ignore enter event.')
          return false // Do not propagate the enter event.
        }
      }
    }
  }

  componentDidUpdate (prevProps) {
    const locationOld = get(prevProps, 'startLocation', null)
    const locationNew = get(this.props, 'startLocation', null)
    const coordsOldLng = get(locationOld, 'coords[0]', null)
    const coordsOldLat = get(locationOld, 'coords[1]', null)
    const coordsNewLng = get(locationNew, 'coords[0]', null)
    const coordsNewLat = get(locationNew, 'coords[1]', null)

    if (coordsOldLng !== coordsNewLng && coordsOldLat !== coordsNewLat) {
      this.update()
    }
  }

  update () {
    const { startLocation, setDirectionsStartLocation } = this.props

    console.log('Update directions start location')

    this.updateMarkerLocation()
    ShowRoute()

    const coords = get(startLocation, 'coords', {})
    const lng = get(coords, '[0]', null)
    const lat = get(coords, '[1]', null)
    if (isNil(lng) || isNil(lat)) {
      console.log('Invalid coordinates... unable to get lng/lat.')
      return
    }
    GetAddressFromHereMaps().getGeoJSONFromLngLat(lng, lat).then(function (geojson) {
      console.log('GetAddressFromHereMaps', geojson)
      setDirectionsStartLocation(coords, geojson)
    }).catch(function (err) {
      console.log('Unable to reverse geocode start location coords.', err)
    })
  }

  componentWillUnmount () {
    this.pure.olLayerMarker.getSource().clear()
    // window.appObject.hideRoute('')
  }

  render () {
    const { classes, startLocation, expanded } = this.props

    if (!expanded) {
      return null
    }

    const textFieldValue = GetLocationLabel(startLocation)

    const textField = (
      <form noValidate autoComplete="off">
        <TextField
          placeholder="Click the map to set starting point"
          label=""
          autoComplete="off"
          spellCheck="false"
          margin={'dense'}
          className={classes.textField}
          value={textFieldValue}
          onChange={this.pure.handleChange}
          variant="outlined"
          InputProps={this.pure.addornment}
        />
      </form>
    )

    return (
      <div className={classes.root}>
        {textField}
      </div>
    )
  }
}

SearchPanelDirectionsStart.propTypes = {
  classes: PropTypes.object.isRequired,
  setDirectionsStartLocation: PropTypes.func.isRequired,
  startLocation: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  pathFinder: PropTypes.object
}

function mapStateToProps (state, ownProps) {
  const startLocation = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, {})
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, true)
  return {
    startLocation,
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDirectionsStartLocation: (startLocation, geojson) => {
      dispatch(setDirectionsStartLocation(startLocation, geojson))
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanelDirectionsStart)
  )
)
